// libraries imports

import { useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

//components and libraries imports

import TrackRecord from "../../components/home/track_records";
import DancingLetters from "../../components/dancingLetters";
import HomeCardSection from "../../components/home/cardsection";
import FaqSection from "../../components/home/faqSection";
import HomeAboutUsSection from "../../components/home/homeAboutUs";
import EndingBanner from "../../components/endingBanner";
import Button from "../../components/button";
import Carousel from "../../components/home/carousel";
import GlobalBanner from "../../components/banner";
import ServiceCards from "../../components/home/serviceCards";

// Data imports from objects
import { bannerBlog, blog } from "../../utilities/blogData";
import DefaultSpacing from "../../utilities/constants";

// styles and images imports

import styles from "../../style/style.module.css";
import GlobeBanner from "../../assets/banner/globe.jpeg";

// Home page component and other codes starts here

const Home = () => {
  document.title = "Home";
  const navigate = useNavigate();

  useEffect(() => {
    window.scroll({ top: 0, behavior: "instant" });
  }, []);

  const padding = new DefaultSpacing();
  const defaultPaddingX = padding.getDefaultPaddingX();
  const defaultPaddingY = padding.getDefaultPaddingY();

  return (
    <>
      <Carousel initialIndex={0} autoSlide={true}>
        <GlobalBanner
          bannerImg={GlobeBanner}
          navLinkText={"Consult With An Expert Now"}
          navLinkRoute={"/contactus"}
          backgroundGradient={true}
          discription="Reliable, precise, and data-driven, empowering your network with industry-leading benchmark testing for seamless performance and connectivity"
        >
          Your <span className="font-extrabold">Trusted Partner</span> For
          <br />
          Network Benchmark Testing
        </GlobalBanner>
        <GlobalBanner
          bannerImg={GlobeBanner}
          navLinkText={"Consult With An Expert Now"}
          navLinkRoute={"/contactus"}
          backgroundGradient={true}
          discription="Ensuring seamless connectivity and top-tier performance for next-gen infotainment systems, because quality drives the experience"
        >
          Infotainment<span className="font-extrabold"> System Testing </span>
          For
          <br />
          High Quality Performance
        </GlobalBanner>
        <GlobalBanner
          bannerImg={GlobeBanner}
          navLinkText={"Consult With An Expert Now"}
          navLinkRoute={"/contactus"}
          backgroundGradient={true}
          discription="Building the future with innovative software development and rigorous testing where quality meets excellence"
        >
          Cutting Edge{" "}
          <span className="font-extrabold">
            Software <br /> Development
          </span>{" "}
          and Testing Services
        </GlobalBanner>
        <GlobalBanner
          bannerImg={GlobeBanner}
          navLinkText={"Consult With An Expert Now"}
          navLinkRoute={"/contactus"}
          backgroundGradient={true}
          discription="Delivering excellence through meticulous quality assurance and testing, because your success demands perfection"
        >
          Top Notch{" "}
          <span className="font-extrabold">
            Quality Assurance, <br /> Testing
          </span>{" "}
          Services
        </GlobalBanner>
      </Carousel>
      <section className={defaultPaddingX}>
        <HomeCardSection />
      </section>

      <section
        className={`bg-visLightBlue ${defaultPaddingX} ${defaultPaddingY} mt-14`}
      >
        <HomeAboutUsSection />
      </section>
      <section className="relative">
        <div
          className={`relative ${defaultPaddingX} top-1/2 z-10 translate-y-1/2`}
        >
          <TrackRecord />
        </div>
        <div className={`${styles.ourServices} `}>
          <div className="w-full items-center justify-center bg-visBlurBlue py-64 text-center text-white">
            <p className="text-base font-thin md:text-lg">OUR SERVICES</p>
            <p className="overflow-hidden py-1 text-2xl font-bold md:text-4xl">
              <DancingLetters title={"What We Bring To You"} />
            </p>
          </div>
        </div>
      </section>

      <section className={`bg-visLightBlue ${defaultPaddingX}`}>
        <div className="relative -top-[5rem] space-y-16">
          <ServiceCards />
          <FaqSection />
        </div>
      </section>

      <section
        className={`bg-visBlue text-white ${defaultPaddingX} ${defaultPaddingY} `}
      >
        <h1 className="text-center text-4xl font-bold tracking-wider">
          OUR BLOGS
        </h1>
        <div className="mt-10 grid h-fit grid-cols-12 gap-5">
          <motion.div
            whileHover={{
              scale: 1.03,
              cursor: "pointer",
              transition: { type: "spring", stiffness: 150, duration: 0.1 },
            }}
            onClick={() => {
              navigate("/blogs/detail/${blog.uuid}", { state: bannerBlog });
            }}
            className="col-span-12 origin-center px-0 md:origin-left lg:col-span-5 lg:origin-right"
          >
            <div className="grid grid-cols-12 place-items-center justify-items-start gap-5 py-0">
              <div className="col-span-12 w-full overflow-hidden rounded-sm sm:col-span-4 lg:col-span-12">
                <img className="w-full" src={bannerBlog.image} alt="" />
              </div>
              <div className="col-span-12 w-full sm:col-span-8 lg:col-span-12">
                <div className="my-3 flex justify-between">
                  <h5 className="rounded-full bg-visOrange px-3 py-1 text-sm font-medium">
                    {bannerBlog.title}
                  </h5>
                  <p className="text-sm font-extralight">{bannerBlog.date}</p>
                </div>
                <p className="text-xl font-medium tracking-[5%]">
                  {bannerBlog.heading}
                </p>
              </div>
            </div>
          </motion.div>
          <div className="col-span-12 flex flex-col justify-between gap-5 lg:col-span-7">
            {blog.slice(0, 3).map((item, index) => {
              return (
                <motion.div
                  whileHover={{
                    scale: 1.03,
                    cursor: "pointer",
                    transition: {
                      type: "spring",
                      stiffness: 150,
                      duration: 0.1,
                    },
                  }}
                  onClick={() => {
                    navigate("/blogs/detail/${blog.uuid}", { state: item });
                  }}
                  key={item + index}
                  className="grid h-full origin-center grid-cols-12 place-items-center gap-6 md:origin-left"
                >
                  <div className="col-span-12 h-full w-full overflow-hidden rounded-sm sm:col-span-4">
                    <img className="h-full w-full" src={item.image} alt="" />
                  </div>
                  <div className="col-span-12 w-full sm:col-span-8">
                    <div className="my-3 flex justify-between">
                      <h5 className="rounded-full bg-visOrange px-3 py-1 text-sm font-medium">
                        {item.title}
                      </h5>
                      <p className="text-sm font-extralight">{item.date}</p>
                    </div>
                    <p className="text-xl font-medium">{item.heading}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
        <div className="mx-auto mt-10 w-fit">
          <Button px="px-10" href={"/blogs"}>
            View All Blogs
          </Button>
        </div>
      </section>
      <EndingBanner buttonText="Contact Now" />
    </>
  );
};

export default Home;
